// ** UI Components
import { Card, CardContent } from "@components/common/card"

// ** Types
import { SummaryCardProps } from "@pma/types"

// ** Helpers
import { cn } from "@pma/utils/helpers"

export function SummaryCard({
  label,
  value,
  icon: Icon,
  iconBg,
  iconColor,
  valueColor,
  badge,
  badgeColor,
}: SummaryCardProps) {
  return (
    <Card className='overflow-hidden border bg-white shadow-sm transition-shadow hover:shadow-md'>
      <CardContent className='flex items-center gap-3 p-4'>
        <div
          className={cn(
            "flex h-12 w-12 shrink-0 items-center justify-center rounded-xl",
            iconBg,
          )}
        >
          <Icon className={cn("h-6 w-6", iconColor)} />
        </div>
        <div className='min-w-0 flex-1'>
          <p className='truncate text-xs font-medium text-muted-foreground'>{label}</p>
          <p className={cn("text-2xl font-bold tabular-nums leading-tight", valueColor)}>
            {value}
          </p>
        </div>
        {badge && (
          <span className={cn("rounded-full px-2 py-1 text-xs font-semibold", badgeColor)}>
            {badge}
          </span>
        )}
      </CardContent>
    </Card>
  )
}
